module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-cake-ee83828fe4201ae38e2b29439a77a4a8.jpg";